var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetaMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4351 5.23706L25.7568 16.1388L28.4712 9.70693L40.4351 5.23706Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54994 5.23706L21.1102 16.2421L18.5286 9.70693L6.54994 5.23706ZM35.1541 30.5073L31.2449 36.4966L39.6093 38.798L42.0138 30.6401L35.1541 30.5073ZM5.00098 30.6401L7.39081 38.798L15.7552 36.4966L11.8459 30.5073L5.00098 30.6401Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.283 20.3874L12.9521 23.9131L21.2575 24.2819L20.9625 15.3569L15.283 20.3874ZM31.702 20.3874L25.9487 15.2537L25.7569 24.2819L34.0476 23.9131L31.702 20.3874ZM15.755 36.4966L20.7412 34.0625L16.4336 30.699L15.755 36.4966ZM26.2437 34.0625L31.2447 36.4966L30.5513 30.699L26.2437 34.0625Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.245 36.4966L26.2441 34.0625L26.6424 37.3227L26.5981 38.6946L31.245 36.4966ZM15.7554 36.4966L20.4023 38.6946L20.3728 37.3227L20.7416 34.0625L15.7554 36.4966Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.476 28.5451L16.3159 27.3207L19.2516 25.9783L20.476 28.5451ZM26.5096 28.5451L27.734 25.9783L30.6844 27.3207L26.5096 28.5451Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.755 36.4966L16.4631 30.5072L11.8457 30.64L15.755 36.4966ZM30.5365 30.5072L31.2446 36.4966L35.1539 30.64L30.5365 30.5072ZM34.0475 23.9131L25.7569 24.2819L26.524 28.5452L27.7484 25.9784L30.6988 27.3208L34.0475 23.9131ZM16.3156 27.3208L19.266 25.9784L20.4756 28.5452L21.2575 24.2819L12.9521 23.9131L16.3156 27.3208Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9521 23.9131L16.4336 30.699L16.3156 27.3208L12.9521 23.9131ZM30.6989 27.3208L30.5513 30.699L34.0476 23.9131L30.6989 27.3208ZM21.2575 24.2819L20.4757 28.5452L21.4493 33.5757L21.6706 26.952L21.2575 24.2819ZM25.7569 24.2819L25.3586 26.9373L25.5356 33.5757L26.524 28.5452L25.7569 24.2819Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5243 28.5452L25.5359 33.5757L26.244 34.0625L30.5516 30.699L30.6992 27.3208L26.5243 28.5452ZM16.3159 27.3208L16.4339 30.699L20.7415 34.0625L21.4496 33.5757L20.476 28.5452L16.3159 27.3208Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5981 38.6946L26.6424 37.3227L26.2736 36.9982H20.7121L20.3728 37.3227L20.4023 38.6946L15.7554 36.4966L17.3781 37.8243L20.6678 40.1108H26.3178L29.6223 37.8243L31.245 36.4966L26.5981 38.6946Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2439 34.0625L25.5358 33.5757H21.4495L20.7414 34.0625L20.3726 37.3227L20.7119 36.9982H26.2734L26.6422 37.3227L26.2439 34.0625Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0547 16.8469L42.3086 10.8281L40.4351 5.23706L26.2436 15.77L31.7019 20.3874L39.4172 22.6445L41.1285 20.6529L40.3909 20.1219L41.571 19.045L40.6564 18.3369L41.8366 17.437L41.0547 16.8469ZM4.69092 10.8281L5.94484 16.8469L5.14823 17.437L6.32839 18.3369L5.42852 19.045L6.60868 20.1219L5.87108 20.6529L7.56757 22.6445L15.2829 20.3874L20.7411 15.77L6.54968 5.23706L4.69092 10.8281Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4175 22.6443L31.7022 20.3873L34.0477 23.913L30.5515 30.6989L35.1541 30.6399H42.0138L39.4175 22.6443ZM15.2831 20.3873L7.56783 22.6443L5.00098 30.6399H11.8459L16.4338 30.6989L12.9523 23.913L15.2831 20.3873ZM25.7571 24.2818L26.2439 15.7699L28.4862 9.70679H18.5286L20.7414 15.7699L21.2577 24.2818L21.4347 26.9667L21.4495 33.5756H25.5358L25.5653 26.9667L25.7571 24.2818Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaMask);
export default __webpack_public_path__ + "static/media/MetaMask.4257454d56902be8cc051e40d16bee74.svg";
export { ForwardRef as ReactComponent };